<template>
  <div class="vogue-cart-wrap">
    <div class="container vogue-cart" v-show="show_car">
      <v-nav-bar v-if="!show_nav" :title="$t('venue.home.shopping_cart')" />
      <h5
        class="title title_font2"
        style="text-transform: Uppercase"
        :style="!show_nav ? '' : 'margin-top:40px'"
      >
        {{ $t("venue.home.shopping_cart") }}
      </h5>
      <a
        class="d-md-block d-none"
        style="margin-bottom: 30px"
        :href="banner_url ? banner_url : null"
        v-if="pc_image && pc_image.url"
      >
        <v-lazy-img  class="d-md-block d-none" :data-url="pc_image.url"    style="width: 100%; height: 100%; object-fit: cover"></v-lazy-img>
      </a>
      <a
        class="d-md-none d-block"
        style="margin-bottom: 20px"
        :href="banner_url ? banner_url : null"
        v-if="(pc_image && pc_image.url) || (mobile_image && mobile_image.url)"
      >
        <v-lazy-img
          :data-url="
            (mobile_image && mobile_image.url) ||
            (pc_image && pc_image.url)
          "
          class="d-md-none d-block lazyload"
          style="width: 100%; height: 100%; object-fit: cover"
        />
      </a>
      <!-- 特殊属性提示 -->
      <div class="special_attrs" v-if="special_attrs_num.has_odd">
        <div class="special_attrs_content">
          <span class="icon-2 iconfont"></span>
          <span
            >Update lenses marked
            <span style="color: red">"Qty 1=1 eye"</span> to even quantities to
            receive them in pair(s).</span
          >
        </div>
      </div>
      <div
        class="empty-cart text-center"
        v-if="emptyCart || error"
      >
        <p class="page_text_font">{{ $t("vogue.cart.empty") }}</p>
        <a
          class="vogue-home-btn transition-main secondary_title"
          href="/collections/all"
        >
          {{ $t("shopping.continue_shipping") }}
        </a>
      </div>
      <div v-show="!(emptyCart || error)"  class="row">
        <div class="col-md-7 col-12 vogue-cart-left">
          <v-PageCartItem
            v-for="item in cartmes.cart"
            theme="athena"
            type="page"
            :key="item.key"
            :cartItem="item"
            :disabled_num="disabled_num"
            :show_currency_selector="show_currency_selector"
            :special_attrs_num="special_attrs_num"
            :changequantity="changequantity"
          ></v-PageCartItem>
        </div>
        <div class="col-md-5 col-12">
          <div v-if="cart_note_off" class="d-none d-md-block">
            <v-cartnote
              :cart_note="this.cart.cart_note"
              wrap_class="cart_note_page"
            ></v-cartnote>
            <hr />
          </div>
          <div class="cart-info">
            <div
              id="discount_price"
              class="cart-info_price"
              v-if="cartmes.discount_cart"
            >
              <p class="secondary_title" v-if="cartmes.coupons.length">
                <span class="iconfont">&#xe718;</span>
                {{
                  Object.values(cartmes.coupons)[0].description
                    ? Object.values(cartmes.coupons)[0].description
                    : Object.values(cartmes.coupons)[0].code
                }}
              </p>
              <p class="secondary_title" v-else>
                {{ $t("shopping.discount") }}
              </p>
              <p>
                -
                <v-selectprice
                  :price="cartmes.discount_cart"
                  :disable_select="true"
                  :fontSize="12"
                  :country="
                    show_currency_selector ? $store.state.pricetype : ''
                  "
                ></v-selectprice>
              </p>
            </div>
            <!-- <hr class="d-none d-md-block" v-if="cartmes.discount_cart" /> -->
            <div id="total" class="cart-info_price">
              <p class="secondary_title">{{ $t("shopping.subtotal") }} :</p>
              <p>
                <v-selectprice
                  :price="complete_subtotal"
                  :disable_select="true"
                  :country="
                    show_currency_selector ? $store.state.pricetype : ''
                  "
                ></v-selectprice>
              </p>
            </div>
            <div class="shopping-carbody-list-foot-tip">
              {{ $t("cart.Taxes_shipping_checkout") }}
            </div>
            <button
              class="checkout secondary_title transition-main"
              :class="{ button_active: checkout_active }"
              :disabled="checkout_active"
              style="margin-top: 15px"
              @click="checkout"
              type="button"
            >
              {{
                cartmes.cart_contents_count
                  ? $t("cart.check_out")
                  : $t("shopping.continue_shipping")
              }}
            </button>
            <v-paypal-btn
              v-if="paypalposition == 'cart' || paypalposition == 'both'"
              style="margin-top: 15px"
              :cartmes="JSON.stringify(cartmes)"
            ></v-paypal-btn>
            <a
              style="color: #999; text-decoration: underline; padding: 10px 0"
              class="secondary_title text-center d-block d-md-none"
              @click.prevent.stop="window.history.go(-1)"
              href="/collections/all"
              >{{ $t("shopping.continue_shipping") }}</a
            >
          </div>
        </div>
      </div>
    </div>
    <v-guess-like
      v-if="recommended_product && show_recommended"
      :recommended_product="recommended_product"
      cart_type="inCart"
      :product_id="product_ids"
      :show_currency_selector="show_currency_selector"
      theme="athena"
      swiperRef="second"
      :palette_config="palette_config"
      :swiper_style="swiper_style"
    ></v-guess-like>
    <div class="container">
      <div class="d-block d-md-none">
        <v-cartnote
          v-if="cart_note_off"
          :cart_note="this.cart.cart_note"
          wrap_class="cart_note_page"
        ></v-cartnote>
      </div>
      <slot name="modules-list"></slot>
    </div>
  </div>
</template>

<script>
import mixCart from "../../../../../js/mixins/mixCart";
import debounce from 'lodash/debounce'
import vPageCartItem from "./pageCartItem.vue";
import vGuessLike from '@/js/components/view/guesslike/guesslike';
import vCartnote from "@/js/components/common/cartnote.vue";
import { mapState } from 'vuex';
export default {
  props: [
    "cart",
    "paypalposition",
    "error",
    "pixel_conversion",
    "current_theme",
    "show_currency_selector",
    "cart_note_off",
    "show_nav",
    "recommended_product",
    "pc_image",
    "mobile_image",
    "banner_url",
    'palette_config',
  ],
  mixins: [mixCart],
  data() {
    return {
      // defaultImage,
      cartmes: "",
      checkout_active: false,
      show_car: true,
      disabled_num: false,
      cartHeight: 0,
      show_recommended: false,
      special_attrs_num: { total: 0 },
      swiper_style: false,
    };
  },
  computed: {
    ...mapState({
      isMobile: ({ isMobile }) => isMobile
    }),
    product_ids() {
      if (!this.cartmes.cart) return;
      let products = Object.values(this.cartmes.cart);
      let ids = [];
      if (!products.length) return "";
      products.forEach((item) => {
        ids.push(item.product_id);
      });
      return ids.join(",");
    },
    window() {
      return window;
    },
    complete_subtotal() {
      let subtotal = this.cartmes.cart_total - this.cartmes.shipping_total;
      if (
        this.cartmes.fees &&
        this.cartmes.fees["shipping-insurance"] &&
        this.cartmes.fees["shipping-insurance"].amount
      ) {
        subtotal = subtotal - this.cartmes.fees["shipping-insurance"].amount;
      }
      return subtotal;
    },
  },
  methods: {
    handleScroll() {
      if (this.isMobile) {
        const cartHeight = this.$(".cart-info").innerHeight();

        // 贝宝按钮加载的比较慢，高度会有所有变化， 高度发生变化后，去掉监听
        if (this.cartHeight > 0 && this.cartHeight !== cartHeight) {
          this.removeScrollListen()
        }

        this.cartHeight = cartHeight;

        this.$(".commonfoot").css("paddingBottom", this.cartHeight + "px");
        this.swiper_style = true;
      } else {
        this.$(".commonfoot").css("paddingBottom", 0);
        this.swiper_style = false;
      }
    },

    // 移除滚动监听
    removeScrollListen() {
      window.removeEventListener('scroll', this.debounceScroll)
    },

    async changequantity(quantity, key, product_id, variant_id) {
      if (this.checkout_active || this.disabled_num) return;
      this.disabled_num = true;
      quantity = this.filterinputnum(quantity, 0);
      this.cartmes.cart[key].quantity = quantity;
      let product_argument = variant_id
        ? { quantity, product_id, variant_id }
        : { quantity, product_id };
      try {
        var res = await this.$axios.put(
          API.changequantity + key,
          {...product_argument,tag:'store'}
        );
        this.disabled_num = false;
        this.cartmes = res.data;
        this.$store.dispatch("change_news_cart", res.data);
        this.$store.dispatch("cartContentsCount", res.data.cart_contents_count);
        localStorage.setItem("cartContentsCount", res.data.cart_contents_count);
      } catch (error) {
        this.disabled_num = false;
        if (
          error?.response?.data?.errors
        ) {
          this.$message.error(Object.values(error.response.data.errors)[0][0]);
        } else if (
          error?.response?.data?.message
        ) {
          this.$message.error(error.response.data.message);
        }
        this.checkout_active = false;
      }
    },
    checkout() {
      this.checkout_active = true;
      let cart_hash = this.getCookie("cart_hash");
      if (window.fbq) {
        let cart_item = Object.values(this.cartmes.cart);
        let content_ids = [];
        let product_category_ids = [];
        cart_item.forEach((item) => {
          content_ids.push(item.product_id);
          if (item.category_ids) {
            product_category_ids = product_category_ids.concat(
              item.category_ids
            );
          }
        });
        if (
          this.pixel_conversion &&
          this.pixel_conversion.pixel_conversion &&
          this.pixel_conversion.pixel_conversion.length &&
          product_category_ids.length
        ) {
          this.initFBevent(
            this.pixel_conversion.pixel_conversion,
            product_category_ids
          );
        }
        this.send_fb_event("InitiateCheckout", {
          content_type: "product_group",
          content_ids,
          value: this.cartmes.cart_total,
          num_items: this.cartmes.cart_contents_count,
          currency: this.cartmes.currency ? this.cartmes.currency : "USD",
        });
      }
      if (window.ttq && window.send_ttp_event) {
        window.send_ttp_event('InitiateCheckout')
      }
      this.$axios.post(API.statis_event, {
        name: "cart.check",
        parameters: { url: window.location.href },
      });
      this.$axios.post(API.statis_event, {
        name: "checkout.check",
        parameters: { url: window.location.href },
      });
      if (window.gtag) {
        window.gtag("event", "cart.check", {
          event_category: "ecommerce",
        });
      }
      if (window._learnq) {
        this.klaviyo_checkout(this.cartmes);
      }
      // if (window.snaptr) {
      //     window.snaptr('track', 'START_CHECKOUT', {
      //         'currency': this.cartmes.currency ? this.cartmes.currency : "USD",
      //         'item_category': null,
      //         'item_ids': this.content_ids,
      //         'number_items': this.cartmes.cart_contents_count,
      //         'price': this.cartmes.cart_total,
      //     })
      // }
      setTimeout(() => {
        this.checkout_active = false;
      }, 5000);
      this.toCheckInfo(cart_hash);
    },
  },
  async beforeMount() {
    if (
      !window.fbq &&
      this.pixel_conversion &&
      this.pixel_conversion.pixel_conversion
    ) {
      this.FBevent();
    }
    this.cart_notices(this.cart, this);
    this.cartmes = this.cart;
    this.$store.dispatch("cartContentsCount", this.cartmes.cart_contents_count);
    localStorage.setItem("cartContentsCount", this.cartmes.cart_contents_count);
    if (window.performance.navigation.type == 2) {
      this.show_car = false
      this.bus.$on('customGetCart', (res) => {
        this.show_car = true
      })
    }
  },
  mounted() {
    this.special_attrs_num = this.computed_special_attrs(this.cart);
    if (this.recommended_product) {
      this.show_recommended = this.recommended_product.shopCart == 1;
    }

    // 仅移动端实现
    if (this.isMobile) {
      this.handleScroll()
      this.debounceScroll = debounce(this.handleScroll, 300);
      window.addEventListener('scroll', this.debounceScroll)
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.debounceScroll)
  },
  watch: {
    "$store.state.news_cart"(newV) {
      this.cartmes = this.$store.state.news_cart;
      this.special_attrs_num = this.computed_special_attrs(newV);
      console.log(this.special_attrs_num, "获取特殊属性的数量");
    },
  },
  components: {
    vPageCartItem,
    vGuessLike,
    vCartnote,
  },
};
</script>

<style lang="scss" scoped>
.vogue-cart-wrap {
  margin-bottom: 40px;
  &::v-deep .note_wrap {
    .note_content {
      width: 100% !important;
      h4 {
        font-size: 16px;
        margin-bottom: 20px;
        text-transform: capitalize;
        font-family: unset !important;
      }
      textarea {
        border: none !important;
        outline: none !important;
        background-color: rgb(250, 250, 250) !important;
      }
    }
  }
  .cart_note_page {
    position: unset !important;
    z-index: 10 !important;
  }
}
.vogue-cart {
  .vogue-cart-left {
    border-right: 1px solid #dedede;
    .note_wrap {
      margin: 20px 0 0 20px;
    }
  }
  .variant {
    font-size: 12px;
    color: #717171;
    & > span:not(:last-child)::after {
      content: " / ";
    }
  }
  .mb-15 {
    margin-bottom: 15px;
  }
  .title {
    font-size: 26px;
    font-weight: bold;
    color: #222222;
    line-height: 36px;
    margin-bottom: 40px;
  }
  .empty-cart {
    font-size: 20px;
    font-weight: 500;
    margin: 90px 0;
    p {
      color: #3f3f3f;
      line-height: 42px;
      margin-bottom: 16px;
    }
    a {
      color: #ffffff;
    }
  }
  .cart-item {
    h5 {
      a {
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
  .cart-info {
    position: sticky;
    padding: 0 20px;
    overflow: hidden;
    #discount_price p {
      font-size: 20px;
      color: #8e929e;
      &::v-deep {
        .product_price_price {
          .money {
            font-size: 20px !important;
            color: #8e929e !important;
          }
        }
      }
    }
    .cart-info_price {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      word-break: break-word;
      margin-bottom: 15px;
      p {
        margin: 0;
        flex: 1;
        line-height: 1;
      }
      p:first-child {
        margin: 0;
        font-weight: 500;
        line-height: 1;
        font-style: normal;
        text-align: left;
        text-transform: lowercase;
        &::first-letter {
          text-transform: uppercase;
        }
      }
      p:last-child {
        text-align: right;
        white-space: nowrap;
      }
    }
    #total {
      font-size: 24px;
      font-weight: bold;
      &::v-deep {
        .product_price_price {
          .money {
            font-size: 24px !important;
          }
        }
      }
      p:first-child {
        font-size: 24px;
        font-weight: bold;
        white-space: nowrap;
      }
    }
    .cart-info_info {
      text-align: center;
      font-size: 12px;
      color: #3a3a3a;
      margin-bottom: 15px;
      opacity: 0.7;
    }
    .checkout {
      width: 100%;
      display: inline-block;
      padding: 14px 20px;
      border: none;
      line-height: 1;
      background: rgb(201, 13, 13) !important;
      color: white;
      font-weight: 600;
      font-style: normal;
      text-transform: uppercase;
      font-size: 16px;
      border-radius: 0;
      cursor: pointer;
      &:hover {
        background: rgb(241, 34, 34) !important;
      }
    }
    .checkout:hover {
        filter: opacity(80%);
    }
    .button_active{
        filter: opacity(60%);
    }
  }
}
.special_attrs {
  display: flex;
  align-items: center;
  height: 68px;
  background: #feeeee;
  font-size: 20px;
  margin-bottom: 50px;
  .special_attrs_content {
    display: flex;
    align-items: center;
    margin-left: 42px;
    span {
      line-height: 28px;
    }
    .iconfont {
      font-size: 26px;
      color: #a72d2d;
      margin: 0 21px 0 0;
    }
  }
}


@media screen and (max-width: 767px) {
  .vogue-cart {
    .vogue-cart-left {
      border-right: none;
      padding-bottom: 0;
    }
    .title {
      font-size: 18px;
      margin-bottom: 5px;
      margin-top: 5px;
    }
    .cart-info {
      position: fixed !important;
      bottom: 0;
      left: 0;
      top: unset !important;
      padding: 15px;
      background: #fafafa;
      z-index: 9;
      width: 100%;
      box-shadow: 0 -2px 4px 0 rgb(0 0 0 / 10%);
      font-size: 12px;
      .cart-info_price {
        margin-bottom: 10px;
      }
      #discount_price p {
        font-size: 14px !important;
        &::v-deep {
          .product_price_price {
            .money {
              font-size: 14px !important;
            }
          }
        }
      }
      #total {
        font-size: 15px !important;
        &::v-deep {
          .product_price_price {
            .money {
              font-size: 15px !important;
            }
          }
        }
        p:first-child {
          font-size: 15px;
        }
      }
    }
  }

  .empty-cart {
    margin: 40px 0 !important;
    p {
      font-size: 16px;
    }
    a {
      font-size: 12px;
    }
  }

  .special_attrs {
    height: 60px;
    font-size: 13px;
    margin-bottom: 30px;
    .special_attrs_content {
      width: 80%;
      margin-left: 15px;
      span {
        line-height: 18px;
      }
      .iconfont {
        font-size: 18px;
      }
    }
  }
  ::v-deep {
    .guess_like {
      .athena_hidden {
        display: none;
      }
      .m_hidden {
        display: block;
      }
      .swiper-command {
        width: 100%;
        bottom: -60px;
        text-align: center;
        line-height: 60px;
        span {
          margin-right: 4px;
          width: 16px;
          height: 8px;
          border-radius: 4px;
        }
        .swiper-pagination-bullet-active {
          transition: width 0.5s;
          width: 32px;
          background: #000;
        }
      }
    }
  }
}
.shopping-carbody-list-foot-tip {
  font-size: 14px;
  text-align: right;
  text-transform: initial;
  word-wrap: break-word;
  margin: 10px 0;
  line-height: 1.5;
}
</style>
